import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ObtieneDatosCookies from "./obtieneDatosCookiesUsuario";
import Swal from "sweetalert2";
import removeCokies from "../tools/removeCokies";
import NuclearExplosion from "./NuclearExplosion";
import socket, { conectarSocket } from "../tools/socke"; // 👈 IMPORTANTE

function WebSocketHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  const Usuario = ObtieneDatosCookies();

  const [eventoCritico, setEventoCritico] = useState(false);

  const explosionSound = new Audio("/explosion.mp3");

  /* ================= 🔌 CONEXIÓN ================= */

  useEffect(() => {
    if (!Usuario?.identificacion) return;

    conectarSocket({ dni: Usuario.identificacion });

//     console.log("🔌 Socket conectado con:", Usuario.identificacion);

    return () => {
      socket.disconnect(); // opcional
    };
  }, [Usuario]);

  /* ================= 🎧 EVENTOS ================= */

  useEffect(() => {
    const handleForzarLogout = (dato) => {
      if (Usuario.destino != 7 && location.pathname !== "/") {

        setEventoCritico(true);
        explosionSound.volume = 0.8;
        explosionSound.play().catch(() => {});

        setTimeout(() => {
          removeCokies();

          Swal.fire({
            title: "🚨 EVENTO CRÍTICO",
            text: dato,
            icon: "warning",
            confirmButtonText: "Aceptar",
            allowOutsideClick: false,
            allowEscapeKey: false
          }).then(() => {
            removeCokies();
            navigate("/");
          });
        }, 2500);
      }
    };

    const handleForzarLogoutUsuario = (dato) => {
      if (Usuario.identificacion == dato && location.pathname !== "/") {

        setEventoCritico(true);
        explosionSound.volume = 0.8;
        explosionSound.play().catch(() => {});

        setTimeout(() => {
          removeCokies();
          navigate("/");
        }, 2500);
      }
    };

    socket.on("forzarLogout", handleForzarLogout);
    socket.on("forzarLogoutUsuario", handleForzarLogoutUsuario);

    return () => {
      socket.off("forzarLogout", handleForzarLogout);
      socket.off("forzarLogoutUsuario", handleForzarLogoutUsuario);
    };
  }, [navigate, location, Usuario]);

  return (
    <>
      <NuclearExplosion
        show={eventoCritico}
        onFinish={() => setEventoCritico(false)}
      />
    </>
  );
}

export default WebSocketHandler;